import {Reducer} from 'redux';
import {
    MapSceneFilterAndSearchReducerActionTypes,
    selectedNewTrafficCenter,
    setNewDfineFilterStatusOnlyRvmNetwork,
    setNewFdVerifiedTrafficJamsFilterStatus,
    setNewPrefixFilterForLayer,
    setNewWazeAlertFilterStatusSet,
    setNewWazeAlertNdwKnownFilterStatus,
    setSituationTypeFilter,
    storeNewSearchResult,
    storeNewSearchValue,
} from '../actions/reducers/filterAndSearch';
import {getBooleanValueFromUrl, getObjectValueFromUrl, getStringValueFromUrl} from '../../../services/UrlService';
import {SearchResults} from '../../../interfaces/SearchFeature';
import {getType} from 'typesafe-actions';
import {otisSituationTypeFilter} from '../../../constants';
import z from 'zod';

const PrefixLayerFilterSchema = z.object({
    mapLayerIDs: z.array(z.string()),
    prefixes: z.array(z.string()),
});
export type PrefixLayerFilter = z.infer<typeof PrefixLayerFilterSchema>;


const PrefixLayerFiltersSchema = z.object({
    avg: PrefixLayerFilterSchema,
    travelTimeV2: PrefixLayerFilterSchema,
});

export type PrefixLayerFilters = z.infer<typeof PrefixLayerFiltersSchema>;

export interface MapFilters {
    currentTrafficCenter: string | null;
    filterTimeStamp: number;
    prefixFilter: PrefixLayerFilters;
    wazeAlertNdwKnown: boolean;
    wazeAlertStatusSet: boolean;
    dFineOnlyRvmNetwork: boolean;
    fdVerifiedTrafficJams: boolean;
    situationTypeFilterOptions: SituationTypeFilter[];
    situationTypeFilters: SituationTypeFilter[];
}

export interface SituationTypeFilter {
    label: string;
    value: string;
}

export interface MapSceneFilterAndSearchReducerState {
    currentSearchValue: string;
    mapFilters: MapFilters;
    searchResults: SearchResults | null;
}

const currentTrafficCenter = getStringValueFromUrl('trafficCenter', '');

const currentSituationTypeFilters = getObjectValueFromUrl('mapFilterSituationType', []);

const initialState: MapSceneFilterAndSearchReducerState = {
    currentSearchValue: '',
    mapFilters: {
        currentTrafficCenter: currentTrafficCenter.length > 0 ? currentTrafficCenter : null,
        dFineOnlyRvmNetwork: getBooleanValueFromUrl('mapFilterDfineRvmNetworkOnly', true),
        filterTimeStamp: Date.now(),
        prefixFilter: getObjectValueFromUrl<PrefixLayerFilters>('prefixFilters', {
            avg: {
                mapLayerIDs: ['flowSpeedArrow_lane1', 'flowSpeedArrow_lane2', 'flowSpeedArrow_lane3', 'flowSpeedArrow_lane4', 'flowSpeedCircle'],
                prefixes: [],
            },
            travelTimeV2: {
                mapLayerIDs: ['traveltime-fcd-line', 'traveltime-fcd-label'],
                prefixes: [],
            }
        }, PrefixLayerFiltersSchema),
        wazeAlertNdwKnown: getBooleanValueFromUrl('mapFilterWazeAlertNdwKnown', false),
        wazeAlertStatusSet: getBooleanValueFromUrl('mapFilterWazeAlertStatusSet', false),
        fdVerifiedTrafficJams: getBooleanValueFromUrl('mapFilterFdVerifiedTrafficJams', true),
        situationTypeFilters: currentSituationTypeFilters,
        situationTypeFilterOptions: otisSituationTypeFilter,
    },
    searchResults: null,
};

const filterAndSearchReducer: Reducer<
    MapSceneFilterAndSearchReducerState,
    MapSceneFilterAndSearchReducerActionTypes
> = (
    state: MapSceneFilterAndSearchReducerState = initialState,
    action: MapSceneFilterAndSearchReducerActionTypes,
): MapSceneFilterAndSearchReducerState => {
    switch (action.type) {
        case getType(selectedNewTrafficCenter):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    currentTrafficCenter: action.payload.newTrafficCenter ? action.payload.newTrafficCenter.name : null,
                    filterTimeStamp: Date.now(),
                },
            };
        case getType(storeNewSearchValue):
            return {
                ...state,
                currentSearchValue: action.payload.searchValue,
            };
        case getType(setNewDfineFilterStatusOnlyRvmNetwork):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    dFineOnlyRvmNetwork: action.payload.newStatus,
                    filterTimeStamp: Date.now(),
                },
            };
        case getType(setNewWazeAlertNdwKnownFilterStatus):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    filterTimeStamp: Date.now(),
                    wazeAlertNdwKnown: action.payload.newStatus,
                },
            };
        case getType(setNewWazeAlertFilterStatusSet):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    filterTimeStamp: Date.now(),
                    wazeAlertStatusSet: action.payload.newStatus,
                },
            };
        case getType(storeNewSearchResult):
            return {
                ...state,
                searchResults: action.payload.searchResults,
            };
        case getType(setNewPrefixFilterForLayer):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    filterTimeStamp: Date.now(),
                    prefixFilter: {
                        ...state.mapFilters.prefixFilter,
                        [action.payload.layerId]: {
                            ...state.mapFilters.prefixFilter[action.payload.layerId],
                            prefixes: action.payload.prefixes,
                        },
                    },
                },
            };
        case getType(setNewFdVerifiedTrafficJamsFilterStatus):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    filterTimeStamp: Date.now(),
                    fdVerifiedTrafficJams: action.payload.newStatus,
                },
            };
        case getType(setSituationTypeFilter):
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    filterTimeStamp: Date.now(),
                    situationTypeFilters: action.payload.situationTypeFilters,
                },
            };
        default:
            return {
                ...state,
            };
    }
};

export default filterAndSearchReducer;
